import React from 'react'

export default function Yes (props) {
  return (
    <svg viewBox="0 0 1024 1024" width={props.width || 200} height={props.height || 200} fill={props.color || '#fff'}>
        <path d="M806.4 415.744L486.4 736.256c-25.6 25.6-64 25.6-89.6 0l-179.2-179.2c-25.6-25.6-25.6-64 0-89.6s64-25.6 89.6 0l134.144 134.144L716.8 326.144c25.6-25.6 64-25.6 89.6 0 25.6 26.112 25.6 70.656 0 89.6z" p-id="1964"></path>
    </svg>
  )
}